export { NewsCard } from './NewsCard.js';
export type { NewsCardProps } from './NewsCard.type.js';
